import $ from 'jquery';

const languageSwitcherDisplay = () => {
  const langItem = $('.wpml-ls-menu-item.wpml-ls-item');

  const langItemMobile = $('.js-lang-mobile');

  if (langItem.length) {
    $.each(langItem, (i, el) => {
      const item = $(el);
      const link = item.find('span[lang]');

      if (link.length) {
        link.text(link.attr('lang'));
      }
    });

    const navLink = langItem.find('.js-nav-link');

    if (navLink.length) {
      navLink.stop().animate({ opacity: 1 }, 200);
    }
  }

  if (langItemMobile.length) {
    const mobileToggler = langItemMobile.find('.js-wpml-ls-item-toggle');
    const mobileSubmenu = langItemMobile.find('.js-wpml-ls-sub-menu');

    const mobileTogglerLangMatch = mobileToggler
      .attr('class')
      .match(/icl-([a-z]{2})/);

    if (mobileTogglerLangMatch.length > 1) {
      const mobileTogglerLang = mobileTogglerLangMatch[1];
      mobileToggler.text(mobileTogglerLang);
    }

    if (mobileSubmenu.length) {
      const mobileSubmenuLink = mobileSubmenu.find('.wpml-ls-link');

      if (mobileSubmenuLink.length) {
        $.each(mobileSubmenuLink, (i, el) => {
          const self = $(el);
          const mobileLangItem = self.find('span[lang]');

          if (mobileLangItem.length) {
            self.text(mobileLangItem.attr('lang'));
          }
        });
      }
    }
  }
};

export default languageSwitcherDisplay();



// WEBPACK FOOTER //
// ./src/scripts/modules/language-switcher-display.js